import { NgModule } from '@angular/core';
import { AgmDirection } from './agm-directions.directive';

@NgModule({
  imports: [
  ],
  declarations: [
    AgmDirection
  ],
  exports: [
    AgmDirection
  ]
})
export class AgmDirectionModule { }


// WEBPACK FOOTER //
// /app/~/agm-direction/src/agm-direction.module.ts